module.exports = __webpack_public_path__ + "static/media/schliffe_fertig.03e6b7af.jpg";